import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FeaturesOffice } from './FeaturesOffice';
import { FeaturesResto } from './FeaturesResto';
import { FeaturesNightclub } from './FeaturesNightclub';

export const ThemeAwareFeatures: React.FC = () => {
  const { theme } = useTheme();

  switch (theme) {
    case 'resto':
      return <FeaturesResto />;
    case 'nightclub':
      return <FeaturesNightclub />;
    case 'office':
    default:
      return <FeaturesOffice />;
  }
};

